(function () {
  function bootGiftCardMedia() {
    if (document.body.dataset.giftCardMediaInit === 'true') return;
    document.body.dataset.giftCardMediaInit = 'true';

    var genderInputs = document.querySelectorAll('#gender-toggle input[name="gender"]');
    var amountInputs = document.querySelectorAll('.giftcard-amounts input[data-variant-input]');
    var carousel = document.querySelector('.product-media-list.mobile-media');
    var pagination = document.querySelector('.media-pagination.mobile-media');
    var desktopList = document.querySelector('.product-media-list.desktop-media');
    var mobileList = document.querySelector('.product-media-list.mobile-media');
    var deliveryRoot = document.querySelector('[data-gift-card-delivery]');
    var physicalHandle = deliveryRoot
      ? deliveryRoot.getAttribute('data-physical-product-handle')
      : '';

    var normalize = function (str) {
      return str ? String(str).toLowerCase().replace(/\s+/g, '-').trim() : '';
    };
    var normalizeAmount = function (str) {
      return normalize(str)
        .replace(/€/g, '')
        .replace(/euros?/g, '')
        .replace(/[^0-9]/g, '');
    };

    var currentIndex = 0;
    var visibleItems = [];
    var physicalMediaPromise = null;
    var physicalMediaReady = false;

    function isPhysicalMode() {
      var physicalTab = document.querySelector('[data-gift-card-tab="physical"]');
      return !!(physicalTab && physicalTab.classList.contains('is-active'));
    }

    function getSelectedAmount() {
      if (isPhysicalMode()) {
        var physicalChecked = document.querySelector('[data-physical-variant-input]:checked');
        if (physicalChecked) {
          if (physicalChecked.dataset.mediaAmountKey) {
            return normalizeAmount(physicalChecked.dataset.mediaAmountKey);
          }
          var parent = physicalChecked.closest('.variant-input');
          if (parent && parent.dataset.value) {
            return normalizeAmount(parent.dataset.value);
          }
        }
        return '';
      }

      var checked =
        document.querySelector('.giftcard-digital-content .giftcard-amounts input[data-variant-input]:checked') ||
        document.querySelector('.giftcard-amounts input[data-variant-input]:checked') ||
        document.querySelector('form.product-single__form input[data-variant-input]:checked');
      return checked ? normalizeAmount(checked.value) : '';
    }

    function getSelectedGender() {
      var checked = document.querySelector('#gender-toggle input[name="gender"]:checked');
      return checked ? normalize(checked.value) : '';
    }

    function hasGenderToggle() {
      return document.querySelectorAll('#gender-toggle input[name="gender"]').length > 0;
    }

    function buildPhysicalMediaItem(src, alt, isMobile) {
      var item = document.createElement('div');
      item.className = 'media-item';
      item.setAttribute('data-gift-media', 'physical');
      item.setAttribute('data-media-color', '');
      item.setAttribute('data-media-genre', 'physique');
      item.style.display = 'none';
      if (isMobile) {
        item.style.minWidth = '300px';
        item.style.scrollSnapAlign = 'start';
        item.style.flexShrink = '0';
      }

      var safeAlt = (alt || 'Carte cadeau physique Pétrone').replace(/"/g, '&quot;');
      var safeSrc = src.indexOf('//') === 0 ? 'https:' + src : src;
      item.innerHTML =
        '<div class="product__media" role="listitem">' +
        '<div class="media media--transparent">' +
        '<img src="' +
        safeSrc +
        '" alt="' +
        safeAlt +
        '" loading="lazy">' +
        '</div></div>';
      return item;
    }

    function ensurePhysicalMedia() {
      if (!physicalHandle) return Promise.resolve(false);
      if (physicalMediaReady) return Promise.resolve(true);
      if (physicalMediaPromise) return physicalMediaPromise;

      var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      physicalMediaPromise = fetch(rootUrl + 'products/' + encodeURIComponent(physicalHandle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Produit physique introuvable');
          return response.json();
        })
        .then(function (product) {
          var media = Array.isArray(product.media) ? product.media : [];
          var images = [];

          if (media.length) {
            media.forEach(function (m) {
              if (!m) return;
              var src = m.src || (m.preview_image && m.preview_image.src);
              if (!src) return;
              images.push({ src: src, alt: m.alt || product.title || '' });
            });
          } else {
            (product.images || []).forEach(function (entry) {
              var src = typeof entry === 'string' ? entry : entry && entry.src;
              if (!src) return;
              images.push({ src: src, alt: product.title || '' });
            });
          }

          images.forEach(function (image) {
            if (desktopList) desktopList.appendChild(buildPhysicalMediaItem(image.src, image.alt, false));
            if (mobileList) mobileList.appendChild(buildPhysicalMediaItem(image.src, image.alt, true));
          });

          physicalMediaReady = true;
          return true;
        })
        .catch(function () {
          physicalMediaPromise = null;
          return false;
        });

      return physicalMediaPromise;
    }

    function displayValue(item) {
      return item.closest('.mobile-media') ? 'block' : 'inline-block';
    }

    function filterList(items, mode, selectedAmount, selectedGender, useGender) {
      var visible = [];

      items.forEach(function (item) {
        var mediaType = item.getAttribute('data-gift-media') || 'digital';
        if (mediaType !== mode) {
          item.style.display = 'none';
          return;
        }

        if (mode === 'physical') {
          item.style.display = displayValue(item);
          visible.push(item);
          return;
        }

        var itemColor = normalizeAmount(item.dataset.mediaColor || '');
        var itemGender = normalize(item.dataset.mediaGenre || '');
        var show = false;
        if (!selectedAmount) {
          show = true;
        } else if (useGender) {
          show = itemColor === selectedAmount && itemGender === selectedGender;
        } else {
          show = itemColor === selectedAmount;
        }

        item.style.display = show ? displayValue(item) : 'none';
        if (show) visible.push(item);
      });

      if (mode === 'digital' && visible.length === 0 && selectedAmount) {
        items.forEach(function (item) {
          var mediaType = item.getAttribute('data-gift-media') || 'digital';
          if (mediaType !== 'digital') return;
          var itemColor = normalizeAmount(item.dataset.mediaColor || '');
          var show = itemColor === selectedAmount;
          item.style.display = show ? displayValue(item) : 'none';
          if (show) visible.push(item);
        });
      }

      if (mode === 'digital' && visible.length === 0) {
        items.forEach(function (item) {
          var mediaType = item.getAttribute('data-gift-media') || 'digital';
          if (mediaType !== 'digital') {
            item.style.display = 'none';
            return;
          }
          item.style.display = displayValue(item);
          visible.push(item);
        });
      }

      return visible;
    }

    function updatePagination() {
      if (!pagination || !carousel) return;
      pagination.innerHTML = '';
      if (visibleItems.length === 0) return;

      visibleItems.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = i === currentIndex ? 'dot active' : 'dot';
        dot.addEventListener('click', function () {
          currentIndex = i;
          scrollToItem(currentIndex);
        });
        pagination.appendChild(dot);
      });
    }

    function updateDots() {
      if (!pagination) return;
      pagination.querySelectorAll('.dot').forEach(function (dot) {
        dot.classList.remove('active');
      });
      var dots = pagination.querySelectorAll('.dot');
      if (dots[currentIndex]) dots[currentIndex].classList.add('active');
    }

    function getItemScrollLeft(item) {
      if (!carousel || !item) return 0;
      return item.getBoundingClientRect().left - carousel.getBoundingClientRect().left + carousel.scrollLeft;
    }

    function getClosestIndex() {
      if (!carousel || visibleItems.length === 0) return 0;
      var left = carousel.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      visibleItems.forEach(function (item, i) {
        var dist = Math.abs(getItemScrollLeft(item) - left);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function scrollToItem(index, smooth) {
      if (!carousel || visibleItems.length === 0) return;
      var target = visibleItems[index];
      if (!target) return;
      currentIndex = index;
      carousel.scrollTo({
        left: getItemScrollLeft(target),
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      updateDots();
    }

    function filterGiftCardImages() {
      var mode = isPhysicalMode() ? 'physical' : 'digital';
      var selectedAmount = getSelectedAmount();
      var selectedGender = getSelectedGender();
      var useGender = hasGenderToggle();

      var apply = function () {
        var desktopItems = Array.prototype.slice.call(document.querySelectorAll('.desktop-media .media-item'));
        filterList(desktopItems, mode, selectedAmount, selectedGender, useGender);

        var mobileItems = Array.prototype.slice.call(document.querySelectorAll('.mobile-media .media-item'));
        visibleItems = filterList(mobileItems, mode, selectedAmount, selectedGender, useGender);
        currentIndex = 0;
        updatePagination();
        scrollToItem(0, false);
      };

      if (mode === 'physical') {
        ensurePhysicalMedia().then(apply);
      } else {
        apply();
      }
    }

    if (carousel) {
      // Snap natif gère le swipe — on met juste à jour les dots
      carousel.addEventListener('scroll', function () {
        clearTimeout(carousel._scrollTimeout);
        carousel._scrollTimeout = setTimeout(function () {
          var index = getClosestIndex();
          if (index !== currentIndex) {
            currentIndex = index;
            updateDots();
          }
        }, 80);
      }, { passive: true });
    }

    amountInputs.forEach(function (el) {
      el.addEventListener('change', filterGiftCardImages);
    });
    genderInputs.forEach(function (el) {
      el.addEventListener('change', filterGiftCardImages);
    });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-physical-variant-input]')) {
        filterGiftCardImages();
      }
    });
    document.addEventListener('gift-card:amount-change', function () {
      requestAnimationFrame(filterGiftCardImages);
    });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.matches('[data-gift-card-tab]')) {
        requestAnimationFrame(filterGiftCardImages);
      }
    });
    document.addEventListener('variant:change', function () {
      requestAnimationFrame(filterGiftCardImages);
    });

    if (physicalHandle) {
      ensurePhysicalMedia();
    }
    filterGiftCardImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootGiftCardMedia);
  } else {
    bootGiftCardMedia();
  }
})();
